import { createException, updateException } from "../../../../redux/specialist-slices/availability.slice";
import { hideDialog, refresher } from "../../../../redux/guest-slices/other.slice";
import { useDispatch, useSelector } from "react-redux";
import { useToast } from "../../../../hooks/useToast";
import TimeUtils from "../../../../utils/time.utils";
import Icons from "../../../../assets/js/Icons";
import { useState } from "react";

import {
  Button, Checkbox, DialogActions, DialogContent,
  DialogTitle, FormControlLabel, Grid2 as Grid,
  IconButton, Paper, TextField, Typography
} from "@mui/material";

function Exception({ handleClose }) {
  const dispatch = useDispatch();
  const toast = useToast();
  const { data } = useSelector((state) => state.otherSlice);
  const [checked, setChecked] = useState(data?.exception?._id ? data?.exception?.fullDay : true);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = new FormData(e.target);
    const formData = Object.fromEntries(form);

    const { date, start, end } = formData;

    let payload = { fullDay: checked, timezone: TimeUtils.getCurrentTimezone() };

    if (checked) {
      payload = {
        ...payload,
        ...TimeUtils.fullDayRange(date)
      };
    } else {
      if (start >= end) {
        toast.error("End time must be greater than start time");
        return;
      }

      payload = {
        ...payload,
        ...TimeUtils.customRange(date, start, end)
      };
    }

    try {
      const { success } = await dispatch(
        data?.exception?._id ?
          updateException({
            data: payload,
            id: data?.exception?._id,
          }) :
          createException(payload)
      ).unwrap() || {};

      if (success) {
        dispatch(hideDialog());
        dispatch(refresher());
      }
    } catch (err) {
      // Error is already handled by the thunk and toast notification is shown
      console.error("Exception creation failed:", err);
    }
  };


  return (
    <Paper component="form" onSubmit={handleSubmit}>
      <DialogTitle sx={{ position: "relative", p: 1 }}>
        <Typography variant="dialogTitle">
          {data?.exception?._id ?
            "Update slot exception" :
            "Create slot exception"
          }
        </Typography>
        <IconButton size="small" variant="dialogCloseBtn" onClick={handleClose}>
          <Icons.Cross />
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers
        className="relative"
        sx={{
          ".MuiInputBase-root": { borderRadius: "6px" },
          textarea: { resize: "none" },
        }}
      >
        <Grid container spacing={1.5} alignItems="center">
          <Grid size={12}>
            <TextField
              fullWidth
              type="date"
              name="date"
              size="small"
              inputProps={{
                min: new Date().toISOString().split("T")[0],
              }}
              defaultValue={
                TimeUtils.inputFieldFormat(
                  data?.exception?.start || new Date()
                )
              }
            />
          </Grid>
          <Grid size={12}>
            <FormControlLabel
              name="fullDay"
              value={true}
              label="Full Day"
              control={<Checkbox
                checked={checked}
                onChange={(e) => { setChecked(e.target.checked) }}
              />}
            />
          </Grid>
          <Grid size="grow">
            <TextField
              fullWidth
              type="time"
              size="small"
              name="start"
              label="Start time"
              disabled={checked}
              slotProps={{ input: { step: 60 } }}
              defaultValue={
                data?.exception?.start ?
                  TimeUtils.formatTo24Hour(data?.exception?.start) :
                  "09:00"
              }
            />
          </Grid>
          <Grid size="grow">
            <TextField
              fullWidth
              name="end"
              type="time"
              size="small"
              label="End time"
              disabled={checked}
              slotProps={{ input: { step: 60 } }}
              defaultValue={
                data?.exception?.end ?
                  TimeUtils.formatTo24Hour(data?.exception?.end) :
                  "17:00"
              }
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          size="small"
          type="submit"
          variant="outlined"
        >{data?.exception?._id ? "Update" : "Create"}
        </Button>
      </DialogActions>
    </Paper>
  )
}

export default Exception;